import { render, staticRenderFns } from "./Images.vue?vue&type=template&id=4564788b&scoped=true"
import script from "./Images.vue?vue&type=script&lang=js"
export * from "./Images.vue?vue&type=script&lang=js"
import style0 from "./Images.vue?vue&type=style&index=0&id=4564788b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4564788b",
  null
  
)

export default component.exports